import { CategoryGeneratorState } from '@quizzach/interfaces';

/**
 * Reads the persisted generator selection ('generatorQuiz'). Corrupt or
 * wrong-shaped data — bad JSON, a non-array, or entries without a
 * subcategories array — is discarded and the key cleared, so a broken blob
 * can never crash a render or leave the configurator stuck on skeletons.
 */
export function readGeneratorSession(): CategoryGeneratorState[] {
	const stored = sessionStorage.getItem('generatorQuiz');
	if (!stored) return [];
	try {
		const parsed = JSON.parse(stored);
		if (
			Array.isArray(parsed) &&
			parsed.every(
				(category) =>
					category &&
					typeof category === 'object' &&
					Array.isArray(category.subcategories)
			)
		) {
			return parsed;
		}
	} catch {
		// fall through to discard
	}
	sessionStorage.removeItem('generatorQuiz');
	return [];
}
